import logo from '@/assets/images/png/logo-alt.png';
import CModal from '@/components/Modal/Modal';
import { routePaths } from '@/config';
import { useAppDispatch } from '@/store';
import { selectDashboardKPI } from '@/store/reducers/dashboard/dashboard.selector';
import { updateUserConnected } from '@/store/reducers/user/user.action';
import { selectUserConnected } from '@/store/reducers/user/user.selector';
import { setAuthToken } from '@/utils/setAuthToken';
import { InlineIcon } from '@iconify/react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	ListItemIcon,
	Menu,
	MenuItem,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import classNames from 'classnames';
import * as moment from 'moment';
import 'moment/locale/fr';
import React, { useState } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import './Header.container.styles.scss';

type THeaderProps = {};
type PropsFromRedux = ConnectedProps<typeof connector>;

const HeaderFct: React.FC<THeaderProps & PropsFromRedux> = ({
	kpi_amount,
	userConnected,
}) => {
	const [openHelp, setOpenHelp] = useState(false);
	const handleOpenHelp = () => setOpenHelp(true);
	const handleCloseHelp = () => setOpenHelp(false);

	const [openLogout, setOpenLogout] = useState(false);
	const handleClickOpenLogout = () => setOpenLogout(true);
	const handleCloseLogout = () => setOpenLogout(false);

	const theme = useTheme();
	const matches_down_lg = useMediaQuery(theme.breakpoints.down('lg'));
	const matches_down_md = useMediaQuery(theme.breakpoints.down('md'));

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const location = useLocation();

	const logout = () => {
		let user: any;
		dispatch(updateUserConnected(user));
		setAuthToken(null);
		navigate(routePaths.auth, { replace: true });
	};

	return (
		<>
			<div className="c-header">
				<img
					src={logo}
					alt="logo"
					className="logo"
					onClick={() =>
						navigate(routePaths.profileChildren.homeAbsolute, {
							replace: true,
						})
					}
				/>
				<p
					className="title uppercase"
					onClick={() =>
						navigate(routePaths.profileChildren.homeAbsolute, {
							replace: true,
						})
					}
				>
					Reporting CDC-CI
				</p>

				{!matches_down_lg && (
					<>
						<div className="updated-time">
							<span className="updated-time__title">
								{' '}
								Date de mise à jour{' '}
							</span>
							{/* <span className="updated-time__value"> {moment.default( kpi_amount.date_maj ).format('LL')} - {moment.default( kpi_amount.date_maj ).format('LT')} </span> */}
							<span className="updated-time__value">
								{' '}
								{kpi_amount.date_maj &&
									moment
										.default(kpi_amount.date_maj)
										.format('LL')}{' '}
							</span>
						</div>

						<Divider
							orientation="vertical"
							variant="middle"
							flexItem
							className="vertical-divider"
						/>

						<div className="nav-part">
							<NavLink
								to={routePaths.profileChildren.homeAbsolute}
								className={
									'nav-link' +
									(location.pathname.indexOf(
										routePaths.profileChildren.homeAbsolute
									) !== -1
										? ' selected'
										: '')
								}
							>
								<InlineIcon icon="fa:dashboard" />
								Accueil
							</NavLink>

							{userConnected?.profil?.libelle?.toLowerCase() ===
								'administrateur' && (
								<NavLink
									to={
										routePaths.profileChildren.usersAbsolute
									}
									className={
										'nav-link' +
										(location.pathname.indexOf(
											routePaths.profileChildren
												.usersAbsolute
										) !== -1
											? ' selected'
											: '')
									}
								>
									<InlineIcon icon="fa-solid:users" />
									Utilisateurs
								</NavLink>
							)}
						</div>

						<Divider
							orientation="vertical"
							variant="middle"
							flexItem
							className="vertical-divider"
						/>
					</>
				)}

				<div
					className={classNames('infos-user', {
						'ml-auto': matches_down_lg,
					})}
					onClick={matches_down_md ? handleClick : undefined}
				>
					<div className="icon-start">
						<InlineIcon icon="carbon:user-avatar-filled-alt" />
					</div>

					{!matches_down_md && (
						<>
							<div className="text">
								<span className="fullname">
									{' '}
									{userConnected?.nom +
										' ' +
										userConnected?.prenoms}{' '}
								</span>
								<span className="role">
									{' '}
									{userConnected?.profil?.libelle}
								</span>
							</div>
							<div className="icon-end" onClick={logout}>
							<InlineIcon  icon="charm:power" className="from-menu" />
								{/* <InlineIcon icon="akar-icons:chevron-down" /> */}
							</div>
						</>
					)}
				</div>
			</div>

			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				PaperProps={{
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						'&:before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				{matches_down_md && (
					<>
						<MenuItem>
							<div className="menu-text">
								<span className="fullname">
									{' '}
									{userConnected?.nom +
										' ' +
										userConnected?.prenoms}{' '}
								</span>
								<span className="role">
									{' '}
									{userConnected?.profil?.libelle}{' '}
								</span>
							</div>
						</MenuItem>
						<Divider />
					</>
				)}
				{matches_down_lg && (
					<>
						<MenuItem>
							<NavLink
								to={routePaths.profileChildren.homeAbsolute}
								className={
									'menu-nav-link' +
									(location.pathname.indexOf(
										routePaths.profileChildren.homeAbsolute
									) !== -1
										? ' selected'
										: '')
								}
							>
								<InlineIcon icon="fa:dashboard" />
								Accueil
							</NavLink>
						</MenuItem>

						{userConnected?.profil?.libelle?.toLowerCase() ===
							'administrateur' && (
							<>
								<MenuItem>
									<NavLink
										to={
											routePaths.profileChildren
												.usersAbsolute
										}
										className={
											'menu-nav-link' +
											(location.pathname.indexOf(
												routePaths.profileChildren
													.usersAbsolute
											) !== -1
												? ' selected'
												: '')
										}
									>
										<InlineIcon icon="fa-solid:users" />
										Utilisateurs
									</NavLink>
								</MenuItem>
							</>
						)}
						<Divider />
					</>
				)}

				{/* <MenuItem onClick={handleOpenHelp}>
          <ListItemIcon>
            <InlineIcon icon="bxs:user-detail" className="from-menu" />
          </ListItemIcon>
          Mon profil
        </MenuItem> */}

				<MenuItem onClick={handleClickOpenLogout}>
					<ListItemIcon>
						<InlineIcon icon="charm:power" className="from-menu" />
					</ListItemIcon>
					Déconnexion
				</MenuItem>
			</Menu>

			<CModal
				open={openHelp}
				onClose={handleCloseHelp}
				closeClick={handleCloseHelp}
			/>
			<Dialog
				open={openLogout}
				onClose={handleCloseLogout}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{'Déconnexion'}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Vous êtes sur le point de vous déconnecter. Êtes-vous
						sûr(e) de vouloir le faire ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button color="tertiary" onClick={handleCloseLogout}>
						Annuler
					</Button>
					<Button color="tertiary" onClick={logout} autoFocus>
						Déconnecter
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

const mapStateToProps = createStructuredSelector({
	kpi_amount: selectDashboardKPI,
	userConnected: selectUserConnected,
});

const connector = connect(mapStateToProps);
const Header = connector(HeaderFct);

export default Header;
